import React, {useState, useEffect, useRef} from 'react';
import styles from './ListLibrat.module.css';
import { GetLibrat, searchBook, searchBookSpecial } from '../../server/server';

const ListLibrat = () => {  
  const [limit, setLimit] = useState(7);
  const [librat, setLibrat] = useState([]);
  const [categories, setCategories] = useState([])
  const searchinput = useRef(null);
  const chosenCategory = useRef(null)
  const chosenSort = useRef(null);

  useEffect(() => {
    let kategorite = [];
    let unique;
    GetLibrat().then((res)=> {
      setLibrat(res.result)
      let librat = res.result;

      librat.forEach((liber)=>{
        kategorite.push(liber.category)
      })
      unique = [...new Set(kategorite)];

      setCategories(unique);
    })
  }, []);
  
  const moreList = () => {
    if (librat.length > limit) {
      setLimit(limit + 7);
    }
  };

  const kerko = () => {
    const toSearch = searchinput.current.value;
    const catoption = chosenCategory.current.value;
    const sortOption = chosenSort.current.value; 
    if(toSearch === "" && catoption === "All" && sortOption === "normal"){
      GetLibrat().then((res)=> {
        setLibrat(res.result)
      })
    }else{
      if(catoption === "All"){
        searchBookSpecial(toSearch, sortOption).then((res)=>{
          setLibrat(res.resu);

        })
      }else{
        searchBook(toSearch, catoption, sortOption).then((res)=> {
          setLibrat(res.resu);
        })
      }
    }
  }

  if(librat === []){
    return(
      <div>loading</div>
    );
  }else{
    return (
      <div>
        <head>
          <title>Alert Page - Xtreme Starter Next Js App</title>
          <meta name="description" content="Generated by create next app" />
          <link rel="icon" href="/favicon.ico" />
        </head>
        <div>
          <p className={styles.title}>Lista e librave   (libra: {librat.length})</p>
          <div className={styles.searchBar}>
            <input
              className={styles.input}
              type="text"
              placeholder="Search for a book"
              ref={searchinput}
            />
            <label className={styles.label} htmlFor="kategoria">
              Kategoria
            </label>
            <select ref={chosenCategory} className={styles.select} name="kategoria" id="">
              <option value="All">All</option>
              {categories.map((uniq, i) => (
                <option key={i} value={uniq}>{uniq}</option>
              ))}
            </select>
            <label className={styles.label} htmlFor="listo">
              Listo sipas
            </label>
            <select ref={chosenSort} className={styles.select} name="listo" id="">
              <option value="normal">Normal</option>
              <option value="emri_A_Z">Emri A-Z</option>
              <option value="stoku">Stoku</option>
            </select>
            <br />
            <div onClick={kerko} className={styles.btn}>Kerko</div>
          </div>
          {/* book list */}
          <div>
            {librat.map(
              (liber, i) =>
                i < limit && (
                  <div key={i} className={styles.bookItem}>
                    <div className={styles.itemInfo}>
                      <p>Titulli: {liber.title}</p>
                      <p>Autori: {liber.author}</p>
                      <p>Kategoria: {liber.category}</p>
                    </div>
                    <div className={styles.itemSituation}>
                      <p>
                        Statusi:{" "}
                        {liber.status ? "Aktiv" : "Ska ne stok"}
                      </p>
                      <p>Stoku: {liber.stock}</p>
                      <p>ID: {liber.isbn}</p>
                    </div>
                  </div>
                )
            )}
            <div onClick={moreList} className={styles.loadMore}>
              <p>Listo me shume Libra</p>
            </div>
          </div>
  
          {/* list end */}
        </div>
      </div>
    )
  }
}

export default ListLibrat;
